import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vorna_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CURRENCY = {
  usd: { code: "usd", label: "USD", symbol: "$", rate: 1 },
  cad: { code: "cad", label: "CAD", symbol: "CA$", rate: 1.38 },
};

export function formatPrice(usd, currency = "usd") {
  const c = CURRENCY[currency] || CURRENCY.usd;
  const val = usd * c.rate;
  return `${c.symbol}${val.toFixed(2)}`;
}
